import { PayloadAction } from '@reduxjs/toolkit';
import { put, select } from 'typed-redux-saga';

import { NotificationId } from '../../call/types';
import { setFetchingStatus } from '../features/fetching/slice';
import { selectIsBatchFetchingFailed } from '../selectors';

export function* resetFetchingErrorSaga(action: PayloadAction<NotificationId>) {
    const isBatchFetchingFailed = yield* select(selectIsBatchFetchingFailed);
    if (action.payload === NotificationId.CONF_HISTORY_FETCHING_FAILED && isBatchFetchingFailed) {
        yield* put(setFetchingStatus(null));
    }
}
